import { Component, Inject, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { SITE_CONTENT_CLICK, SiteContentClickEvent } from '../site-content/site-content.component';

@Component({
  selector: 'app-help-popup',
  templateUrl: './help-popup.component.html',
  styleUrls: ['./help-popup.component.scss'],
})
export class HelpPopupComponent implements OnInit {

  @Input() key: string;

  showHelp = false;

  constructor(
    @Inject(SITE_CONTENT_CLICK) private siteContentClick: Subject<SiteContentClickEvent>
  ) { }


  async ngOnInit() {
    // we need to close the popup if we're showing the cover calculator from quick quote    
    this.siteContentClick.subscribe(x => {
      const target = <HTMLAnchorElement>x.event.currentTarget;
      if (target.href.startsWith('https://app/')) {
        this.showHelp = false;
      }
    })
  }

}
